import 'jquery';

export class Datepicker {

    initialize() {
        this._disableTouchKeyboard();
    }

    _disableTouchKeyboard() {

        var hasTouch = 'ontouchstart' in window;

        if (hasTouch) {
            $('.input-group.date > input').on('mousedown', function (e) {
                var $date = $(e.target).parent('.date');
                $date.datepicker('show');
                e.preventDefault();
                return false;
            });
        }
    }
}